// Optional reasons shown when an owner removes a listing or a user deletes
// their account. The account list must match ACCOUNT_DELETE_REASONS in the
// backend's server.js (anything else is saved as no reason).
export const LISTING_REMOVAL_REASONS = ['Sold the item', 'No hires', 'Too hard to use', 'Other']
export const ACCOUNT_DELETION_REASONS = ['No hires', 'Too hard to use', "Don't need it any more", 'Other']
